import { useEffect, useState } from "react";
import axios from "axios";

import { API_URL } from "../config";

// Articles come from the "aktuality" Google Sheet through the API server.
// The server already sorts nothing, so the sheet order is the display order:
// newest first, which is how the sheet is meant to be kept.
export default function useArticles(limit) {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await axios.get(`${API_URL}/articles`);
        if (cancelled) return;

        const data = Array.isArray(response.data) ? response.data : [];
        setArticles(limit ? data.slice(0, limit) : data);
        setError(null);
      } catch (err) {
        if (!cancelled) setError("Novinky se nepodařilo načíst");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [limit]);

  return { articles, loading, error };
}

// The sheet holds plain text, so the excerpt is a simple truncation on a
// word boundary rather than a markdown-aware one.
export function excerpt(text, length = 300) {
  const plain = (text || "").replace(/<[^>]*>/g, "").trim();
  if (plain.length <= length) return plain;

  const cut = plain.slice(0, length);
  return `${cut.slice(0, cut.lastIndexOf(" ")) || cut}…`;
}
